import { AfterViewInit, Component, ContentChild, Input, Optional } from "@angular/core";
import { NgModel, ValidationErrors } from "@angular/forms";
import { BreezeValidatorDirective } from "./breeze-validator.directive";
import { Parent } from "./parent";

@Component({
  selector: "uni-field",
  template: ` <div class="p-field p-fluid">
    <div class="flex justify-between">
      <label class="pt-1" [ngClass]="labelClass" [innerHTML]="label">{{ isRequired ? "*" : "" }} </label><span class="ml-4 pt-2 text-xs text-gray-500">{{hint}}</span>
      <span class="pb-1"><ng-content select="[extendedLabel]"></ng-content></span>
    </div>
    <div>
      <ng-content></ng-content>
      <small id="username-help" *ngIf="hasErrors" class="uni-error">{{ message }}</small>
    </div>
  </div>`,
  standalone: false,
})
export class UniFieldComponent implements AfterViewInit {
  @Input() label = `&nbsp;`; // can't use '' here because this gets collapsed to nothing. - also why we need to bing label to [innerHTML] above.
  @Input() hint = '';
  @Input() labelClass = '';
  @ContentChild(NgModel) ngm?: NgModel;
  @ContentChild(BreezeValidatorDirective) bzModel?: BreezeValidatorDirective;
  private _required?: boolean;

  constructor(@Optional() public parent?: Parent) { }

  ngAfterViewInit() {
    if (!this.ngm) return;
    const ngm = this.ngm;

    setTimeout(() => this.checkReadOnly(ngm), 1);
  }

  checkReadOnly(ngm: NgModel) {
    if (this.parent?.isReadOnly?.()) {
      ngm.control.disable();
    }
  }

  get hasErrors(): boolean {
    return this.bzModel?.hasValidationErrors || !!(this.ngm && this.ngm.invalid && this.ngm.dirty);
  }

  get isRequired(): boolean {
    if (this._required === undefined && this.bzModel) {
      this._required = this.bzModel.isRequired;
    }
    return !!this._required;
  }

  get message(): string {
    const ers = this.ngm && this.ngm.errors;
    return UniFieldComponent.getValidationMessage(ers);
  }

  /** Get the messages from the errors object from an NgModel */
  static getValidationMessage(ers: ValidationErrors): string {
    if (!ers) {
      return "";
    }
    const keys = Object.keys(ers);
    const arr: string[] = [];
    // Errors from BreezeValidatorDirective are like: { maxLength: "'Name' must be a string with 100 characters or less"}
    // Html form validation errors are like: { maxlength: {"requiredLength":10,"actualLength":26}} but we shouldn't have those
    for (const key of keys) {
      const val = ers[key];
      if (typeof val === "string") {
        arr.push(val);
      } else if (val.message) {
        arr.push(val.message);
      } else if (key == "required") {
        arr.push("Required");
      } else if (key == "email") {
        arr.push("Must be a valid email address");
      } else if (key == "minlength") {
        arr.push(`Must be at least ${val.requiredLength} characters`);
      } else if (key == "maxlength") {
        arr.push(`Must be at most ${val.requiredLength} characters`);
      } else if (key == "pattern") {
        // arr.push('Invalid value'); form should validate this separately
      } else {
        arr.push(key + ": " + JSON.stringify(val));
      }
    }
    return arr.join("; ");
  }
}
